<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M217.018 37.6896H9.6V191.821C9.6 202.842 18.5344 211.77 29.5488 211.77H217.011V37.6896H217.018Z"
      class="fill-brand-100"
    />
    <path
      d="M246.675 65.4207H246.714L238.822 37.3951L230.477 65.4015H230.509C230.413 65.7919 230.349 66.2015 230.349 66.6239V236.781C230.349 239.539 232.582 241.773 235.341 241.773H241.837C244.595 241.773 246.829 239.539 246.829 236.781V66.6175C246.829 66.2015 246.771 65.8047 246.675 65.4207Z"
      class="fill-secondary-500"
    />
    <path
      d="M30.3616 170.246H42.7648V14.08H29.6832C18.592 14.08 9.6 23.072 9.6 34.1632V191.014C9.6 179.546 18.8928 170.253 30.3616 170.253V170.246Z"
      class="fill-brand-500"
    />
    <path
      d="M75.2064 122.861V192.858H88.3776V152.762C88.3776 151.354 89.5232 150.208 90.9312 150.208H109.184C110.592 150.208 111.738 151.354 111.738 152.762V192.858H185.837V122.861H75.2064ZM144.32 164.218H124.211V141.99C124.211 140.774 125.197 139.789 126.413 139.789H142.118C143.334 139.789 144.32 140.774 144.32 141.99V164.218ZM174.304 164.218H154.195V141.99C154.195 140.774 155.181 139.789 156.397 139.789H172.102C173.318 139.789 174.304 140.774 174.304 141.99V164.218Z"
      class="fill-brand-300"
    />
    <path
      d="M195.341 119.27L132.102 56.032C131.226 55.1552 129.805 55.1552 128.928 56.032L95.5904 89.3696V76.1472C95.5904 74.304 94.0992 72.8128 92.2496 72.8128H85.9136C84.0704 72.8128 82.5728 74.304 82.5728 76.1472V102.381L65.6832 119.27C64.2688 120.685 65.2736 123.104 67.2704 123.104H193.741C195.744 123.104 196.742 120.685 195.328 119.27H195.341ZM128.109 104.736C123.411 104.736 119.61 100.928 119.61 96.2368C119.61 91.5456 123.418 87.7376 128.109 87.7376C132.8 87.7376 136.608 91.5456 136.608 96.2368C136.608 100.928 132.8 104.736 128.109 104.736Z"
      class="fill-brand-500"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Renovating'
  }
</script>
